import { render, staticRenderFns } from "./ActivateSecurityUser.vue?vue&type=template&id=2c766bf8&"
import script from "./ActivateSecurityUser.vue?vue&type=script&lang=js&"
export * from "./ActivateSecurityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports